import { useTranslation } from "next-i18next";
import Image from "next/legacy/image";
import { useEffect, useState } from "react";
import HeroButton from "../../UI/HeroButton";
import { ConfirmModal } from "./confirm-modal";
import raffleImg from "../../../public/img/nft-auth/raffle.png";
import CloseIcon from "../../../public/icon/icon-close.svg";
import { lottery20220807 } from "../../../constants/lottery";
import dayjs from "dayjs";
import Button from "@/components/UI/Button";
import { useRouter } from "next/router";
import { lotteryBind, lotteryList } from "utils/api";
import { useSnackbar } from "notistack";
import classNames from "classnames";

const useBottom = () => {
  const [bottom, setBottom] = useState(-168);
  useEffect(() => {
    setTimeout(() => {
      setBottom(14);
    }, 100);
  }, []);

  return bottom;
};

const Lottery20220807Cn = ({
  isOverdue,
  lotteryInfo,
  setConfirmModalVisible,
  onClose,
}) => {
  const bottom = useBottom();

  return (
    <div
      className="font-cn fixed z-[1] left-1/2 -translate-x-1/2  w-[940px] h-[94px] rounded-[32px] p-[4px] bg-hero transition-all ease-bounce duration-300"
      style={{ bottom }}
    >
      <div className="bg-black absolute w-[932px] h-[86px] top-[4px] left-[4px] rounded-[28px]"></div>
      <div className="mt-[4px] ml-[4px] w-[928px] h-[78px] rounded-[24px] bg-[#1D1D1D] text-white flex items-center justify-between pl-[24px] pr-[12px] relative z-[1]">
        <div className="flex flex-1 items-center font-bold">
          <div className="mb-[20px] mr-[4px]">
            <Image src={raffleImg} width={146} height={89} alt="" />
          </div>
          <div>
            <div className="text-[16px] font-medium">
              抽奖活动报名：抽取“干杯！故宫”数字藏品空投的授权资格
            </div>
            <div className="text-[12px] font-light text-white opacity-60 mt-[6px]">
              报名截止日期：2022年8月18日 11:00
              <span className="mx-[8px]">|</span>
              开奖日期：2022年8月18日 18:00
            </div>
          </div>
        </div>
        <div className="w-[240px] h-[40px]">
          {!lotteryInfo?.uid ? (
            isOverdue ? (
              <Button
                variant="contained"
                color="info"
                className="w-full h-full rounded-full text-[16px] font-medium"
                disabled
              >
                <span>报名已结束</span>
              </Button>
            ) : (
              <HeroButton
                className="w-full h-full text-[16px] font-cn font-normal"
                onClick={() => {
                  setConfirmModalVisible(true);
                }}
              >
                登记授权UID完成报名
              </HeroButton>
            )
          ) : (
            <Button
              variant="contained"
              color="info"
              className={classNames(
                "w-full h-full rounded-full font-cn font-normal whitespace-nowrap",
                lotteryInfo.uid.length > 10 ? "text-[12px]" : "text-[16px]"
              )}
              disabled
            >
              <span>已授权UID：{lotteryInfo?.uid}</span>
            </Button>
          )}
        </div>
        <button
          className="btn-unstyled ml-[12px] w-[32px] h-[32px] flex items-center justify-center transition hover:opacity-80 "
          onClick={onClose}
        >
          <CloseIcon width={12} />
        </button>
      </div>
    </div>
  );
};

const Lottery20220807En = ({
  isOverdue,
  lotteryInfo,
  setConfirmModalVisible,
  onClose,
}) => {
  const bottom = useBottom();

  const endTime = new Date(+dayjs(lottery20220807.registrationDeadline));

  console.log("endTime", endTime);

  return (
    <div
      className="fixed z-[1] left-1/2 -translate-x-1/2  w-[940px] h-[118px] rounded-[32px] p-[4px] bg-hero transition-all ease-bounce duration-300"
      style={{ bottom }}
    >
      <div className="bg-black absolute w-[932px] h-[110px] top-[4px] left-[4px] rounded-[28px]"></div>
      <div className="mt-[4px] ml-[4px] w-[924px] h-[102px] rounded-[24px] bg-[#1D1D1D] text-white flex items-center justify-between pl-[24px] pr-[12px] relative z-[1]">
        <div className="flex flex-1 items-center font-bold">
          <div className="mr-[12px]">
            <Image src={raffleImg} width={146} height={89} alt="" />
          </div>
          <div>
            <div className="text-[16px] font-medium">
              LUCKY DRAW activity: “干杯！故宫” airdrop authorization
              <br />
              qualification (20 winners)
            </div>
            <div className="text-[12px] font-light text-white opacity-60 mt-[6px]">
              Registration deadline: 2022.08.18 11:00 (UTC+8) <br />
              Lucky draw time: 2022.08.18 18:00 (UTC+8)
            </div>
          </div>
        </div>
        <div className="w-[240px] h-[40px]">
          {!lotteryInfo?.uid ? (
            isOverdue ? (
              <Button
                variant="contained"
                color="info"
                className="w-full h-full rounded-full text-[16px] font-medium"
                disabled
              >
                <span>Registeration closed</span>
              </Button>
            ) : (
              <HeroButton
                className="w-full h-full text-[16px] font-medium"
                onClick={() => {
                  setConfirmModalVisible(true);
                }}
              >
                Authorize UID & Register
              </HeroButton>
            )
          ) : (
            <Button
              variant="contained"
              color="info"
              className={classNames(
                "w-full h-full rounded-full font-medium whitespace-nowrap",
                lotteryInfo.uid.length > 10 ? "text-[12px]" : "text-[16px]"
              )}
              disabled
            >
              <span>Authorized UID: {lotteryInfo.uid}</span>
            </Button>
          )}
        </div>
        <button
          className="btn-unstyled ml-[12px] w-[32px] h-[32px] flex items-center justify-center transition hover:opacity-80 "
          onClick={onClose}
        >
          <CloseIcon width={12} />
        </button>
      </div>
    </div>
  );
};

export const Lottery20220807 = ({ onClose }) => {
  const { locale } = useRouter();
  const [lotteryInfo, setLotteryInfo] = useState({});
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation("nftauth");
  const [isOverdue, setIsOverdue] = useState(false);

  const [confirmModalVisible, setConfirmModalVisible] = useState(false);

  const compProps = { isOverdue, lotteryInfo, setConfirmModalVisible, onClose };
  console.log("compProps", compProps);

  const handleUidConfirm = async (uid) => {
    const { data, err } = await lotteryBind({ biliUid: uid });

    fetchLottery();

    if (err) {
      enqueueSnackbar(t("t24"), { variant: "error" });
      return;
    }

    enqueueSnackbar(t("t26"), { variant: "success" });
    setConfirmModalVisible(false);
  };

  const fetchLottery = async () => {
    const { data, err } = await lotteryList();
    console.log("lotteryList", { data, err });

    if (err) {
      return;
    }

    setLotteryInfo(data.item);
  };

  useEffect(() => {
    fetchLottery();

    const now = dayjs();
    const registrationDeadline = dayjs(lottery20220807.registrationDeadline);
    setIsOverdue(now.isAfter(registrationDeadline));
  }, []);

  return (
    <>
      {locale === "cn" ? (
        <Lottery20220807Cn {...compProps} />
      ) : (
        <Lottery20220807En {...compProps} />
      )}
      {confirmModalVisible && (
        <ConfirmModal
          onCancel={() => {
            setConfirmModalVisible(false);
          }}
          onUidConfirm={handleUidConfirm}
        />
      )}
    </>
  );
};
